class QuantitySelectorMixAndMatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.crateFull = false;
      this.inputElement = this.querySelector("input");
      this.inputPlus = this.querySelector('.quantity-selector__button:has(.icon-plus)')
      this.inputMinus = this.querySelector('.quantity-selector__button:has(.icon-minus)')
      this.inputPlus.addEventListener('click', this.handleClickPlus.bind(this));
      this.inputMinus.addEventListener('click', this.handleClickMinus.bind(this));
      document.addEventListener('crate-full', this.setCrateFull.bind(this));
      this.inital()
    }

    inital() {
      const data = localStorage.getItem('mixAndMatchItems') ? JSON.parse(localStorage.getItem('mixAndMatchItems')) : null;
      if(data) {
        if(data.arrID.includes(this.inputElement.getAttribute('productid'))) {
          // get the position of the item in the array
          const index = data.arrID.indexOf(this.inputElement.getAttribute('productid'));
          this.inputElement.value = data.arrAmount[index] / 3;
        }
      }
    }
    setCrateFull(event){
      this.crateFull = event.detail.value;
    }

    handleClickPlus() {
        if(Number(this.inputElement.value) + 1 <= Number(this.inputElement.max) && this.crateFull == false) {
            this.inputElement.value = Number(this.inputElement.value) + 1;
            this.handleClick()
        } else if(this.crateFull){
          this.querySelector('.mix-and-match-notification.crate-full').style.display = 'block';
          setTimeout(()=> {
            this.querySelector('.mix-and-match-notification.crate-full').style.display = 'none';
          },2500)
        }else if(Number(this.inputElement.value) == Number(this.inputElement.max) && this.crateFull == false) {
            this.querySelector('.mix-and-match-notification.out-of-stock').style.display = 'block';
            setTimeout(()=> {
              this.querySelector('.mix-and-match-notification.out-of-stock').style.display = 'none';
            },2500)
        }
    }
    handleClickMinus() {
        if(Number(this.inputElement.value) - 1 >= 0) {
            this.inputElement.value = Number(this.inputElement.value) - 1;
            this.handleClick()
        }
    }
    handleClick() {
      document.dispatchEvent(new CustomEvent('quantity-changed', {
        detail: {
          value: this.inputElement.value,
          id: this.inputElement.getAttribute('productid'),
          title: this.inputElement.title,
          price: this.inputElement.getAttribute('product-price'),
          unitPrice: this.inputElement.getAttribute('unit-price'),
          handle: this.inputElement.getAttribute('product-handle')
        },
        bubbles: true,
        composed: true
      }));
    }
  }

  customElements.define('quantity-selector-mix-and-match', QuantitySelectorMixAndMatch);

  class MixAndMatchSummary extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.steps = Number(this.getAttribute('steps'));
      this.totalAmount = 0;
      this.maxAmount = Number(this.getAttribute('max-amount'));
      this.arrID = [];
      this.arrAmount = [];
      this.arrPrice = [];
      this.arrUnitPrice = [];
      this.arrLink = [];
      this.arrTitle = [];
      this.crateItems = this.querySelector('.crate-items');
      this.carteInfo = this.querySelector('.crate-info')
      this.carteButton = this.querySelector('.buy-button-mix-match');
      this.propertyItem = this.querySelector('#property-bundle-items');
      this.propertyQuantities = this.querySelector('#property-bundle-quantities');
      document.addEventListener('quantity-changed', this.handleQuantityChange.bind(this));
      this.querySelector('.mix-and-match-header').addEventListener('click', this.handleOpenSummery.bind(this));
      this.carteButton.querySelectorAll('button')[1].addEventListener('click', () => this.handleAddToCart());
      this.buildSummary();
    }

    buildSummary(){
      const data = localStorage.getItem('mixAndMatchItems') ? JSON.parse(localStorage.getItem('mixAndMatchItems')) : null;
      if(data){
          this.arrAmount = data.arrAmount;
          this.arrID = data.arrID;
          this.arrPrice = data.arrPrice;
          this.arrUnitPrice = data.arrUnitPrice;
          this.totalAmount = data.totalAmount;
          this.arrLink = data.arrLink;
          this.arrTitle = data.arrTitle;
          this.updateSummery();

          const tempContainer = document.createElement('div');
          this.arrID.forEach((id, index) => {
            let htmlTemplate = `
            <div class="js-crate-item flex align-center justify-between text-sm" item-id="${id}">
              <div class="flex gap-2">
                <p class="js-crate-qty bold">${this.arrAmount[index]}x</p>
                <a href="${this.arrLink[index]}">${this.arrTitle[index]}</a>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="11" viewBox="0 0 22 11" fill="none">
                <path d="M7 9L14 2" stroke="#363636"/>
                <path d="M14 9L7 2" stroke="#363636"/>
              </svg>
            </div
            `;

            tempContainer.innerHTML += htmlTemplate;
          })
          this.crateItems.appendChild(tempContainer);
          tempContainer.querySelectorAll(`.js-crate-item svg`).forEach((svg, index) => {
            svg.addEventListener('click', () => this.removeItem(this.arrID[index], index));
        });
      }
    }

    handleCloseSummery(e){
      this.toggleAttribute('open');
      e.target.remove()
    }

    handleOpenSummery(event){
      const crateItem = event.target.closest('.js-crate-item');
      if (crateItem) return
      this.toggleAttribute('open');
      if(this.hasAttribute('open')) {
        const overlay = document.createElement("div");
        overlay.classList.add('mix-and-match-overlay')
        document.body.appendChild(overlay);
        overlay.addEventListener('click', (e) => this.handleCloseSummery(e))
      }else{
        document.querySelector('.mix-and-match-overlay') && document.querySelector('.mix-and-match-overlay').remove();
      }

    }

    updateSummery(){
      this.totalAmount = this.arrAmount.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      if(this.totalAmount >= this.maxAmount){
        this.setAttribute('data-status', "full");
      } else if (this.totalAmount == 0){
        this.setAttribute('data-status', "empty");

        this.carteInfo.querySelector('span').innerHTML = this.maxAmount;
        this.carteButton.querySelector('span').innerHTML = this.maxAmount;
      } else {
        this.setAttribute('data-status', "filled");

        this.carteInfo.querySelector('span').innerHTML = this.maxAmount - this.totalAmount;
        this.carteButton.querySelector('span').innerHTML = this.maxAmount - this.totalAmount;
      }

      document.dispatchEvent(new CustomEvent('crate-full', {
        detail: {
          value: this.totalAmount >= this.maxAmount
        },
        bubbles: true,
        composed: true
      }));

      const unitPrice = this.arrUnitPrice.reduce((accumulator, currentValue) => (accumulator) + currentValue, 0) / this.totalAmount;
      const price = this.arrPrice.reduce((accumulator, currentValue) => (accumulator) + currentValue, 0);
      this.querySelector('.product-info__price .price').innerHTML = Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(price / 100);
      this.querySelector('.product-info__price .unit-price').innerHTML = `(${Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(unitPrice / 100)} /l)`
      this.querySelector('.product-info__price .unit-price-variants').innerHTML = `${Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format((price/100) / this.totalAmount)} pro Flasche`
    };

    updateLocalStorage(){
      localStorage.setItem('mixAndMatchItems', JSON.stringify({
        arrID: this.arrID,
        arrAmount: this.arrAmount,
        arrPrice: this.arrPrice,
        arrUnitPrice: this.arrUnitPrice,
        totalAmount: this.totalAmount,
        arrLink: this.arrLink,
        arrTitle: this.arrTitle
      }));
    }

    addItem(quantity, title, id, index,price,unitPrice ,link){
      this.arrID.push(id);
      this.arrAmount.push(quantity);
      this.arrPrice.push(price * quantity);
      this.arrUnitPrice.push(unitPrice * quantity);
      this.arrLink.push(link);
      this.arrTitle.push(title);
      let htmlTemplate = `
      <div class="js-crate-item flex align-center justify-between text-sm" item-id="${id}">
        <div class="flex gap-2">
          <p class="js-crate-qty bold">${quantity}x</p>
          <a href="${link}">${title}</a>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="11" viewBox="0 0 22 11" fill="none">
          <path d="M7 9L14 2" stroke="#363636"/>
          <path d="M14 9L7 2" stroke="#363636"/>
        </svg>
      </div
      `;
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = htmlTemplate;
      tempContainer.querySelector('svg').addEventListener('click', () => {
        this.removeItem(id,index);
        document.querySelector(`.product-info__quantity-selector input[productid="${id}"]`).value = 0;
      })
      this.crateItems.appendChild(tempContainer.firstElementChild);
      this.updateSummery();
      this.updateLocalStorage();
    }

    removeItem(id, index){
      this.arrID.splice(index, 1);
      this.arrAmount.splice(index, 1);
      this.arrPrice.splice(index, 1);
      this.arrUnitPrice.splice(index, 1);
      this.arrLink.splice(index, 1);
      this.arrTitle.splice(index, 1);
      this.querySelector(`.js-crate-item[item-id="${id}"]`).remove();
      this.updateSummery();
      this.updateLocalStorage();
    }

    updateItem(quantity,id,index, price, unitPrice){
      this.arrID[index] = id;
      this.arrAmount[index] = quantity;
      this.arrPrice[index] = price * quantity;
      this.arrUnitPrice[index] = unitPrice * quantity;
      this.querySelector(`.js-crate-item[item-id="${id}"] .js-crate-qty`).innerHTML = quantity + "x";
      this.updateSummery();
      this.updateLocalStorage();
    }

    handleQuantityChange(event) {
      const quantity = Number(event.detail.value) * this.steps;
      const id = event.detail.id;
      const title = event.detail.title;
      const price = Number(event.detail.price);
      const unitPrice = Number(event.detail.unitPrice);
      const link = `/products/${event.detail.handle}`;
      let index = this.arrID.indexOf(id);

      if(index == -1) {
        this.addItem(quantity, title, id, index, price, unitPrice, link);
      } else if (quantity == 0){
        this.removeItem(id, index, price, unitPrice)
      }else{
        this.updateItem(quantity, id, index, price, unitPrice);
      }

      this.propertyItem.setAttribute('value', this.arrID);
      this.propertyQuantities.setAttribute('value', this.arrAmount);
    }

    handleAddToCart(){
      let formData = {
        'items': []
       };
       let bundle = Math.floor(Math.random() * 100000)
       const depositType = this.getAttribute('deposit-type') || 'bottle';
       const isCanDeposit = depositType === 'can';

       this.arrID.forEach((product,index) => {
        const properties = {
          'Mix&Match': 'Bundle',
          '_bundle': bundle,
          "_amount": this.arrAmount[index],
          "_totalAmount": this.totalAmount
        };

        // Set the appropriate deposit property based on deposit type
        if (isCanDeposit) {
          properties['_deposit_can'] = 'true';
        } else {
          properties['_deposit'] = 'true';
        }

        formData.items.push({
          'id': product,
          "quantity": this.arrAmount[index],
          'properties': properties
        });
       })

       // Add the appropriate deposit product based on setting
       if (isCanDeposit && window.depositCan) {
         formData.items.push({'id': window.depositCan, "quantity": this.totalAmount});
       } else if (!isCanDeposit && window.depositBottle) {
         formData.items.push({'id': window.depositBottle, "quantity": this.totalAmount});
       }

       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(() => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
        })))
       .then(() => document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          cart: {
            items: formData.items
          }
        }
        })))
        .then(()=> {
          document.querySelector('cart-drawer').setAttribute('open', '');
          localStorage.setItem('mixAndMatchItems','');
          this.arrAmount = [];
          this.arrID = [];
          this.arrPrice = [];
          this.arrUnitPrice = [];
          this.arrLink = [];
          this.arrTitle = [];
          this.totalAmount = 0;
          this.updateSummery();
          this.crateItems.innerHTML = '';
          document.querySelectorAll('quantity-selector-mix-and-match input').forEach((input) => input.value = 0);
      })
       .catch((error) => {
         console.error('Error:', error);
       });
    }
  }

  customElements.define('mix-and-match-summery', MixAndMatchSummary);
